import BaseCachedDataService from '@/core/services/cachedData/BaseCachedDataService'
import { TagsData } from '@/types/api'

import { ContentsApi } from '@/api/languageApi'

class TagsCachedDataService extends BaseCachedDataService<TagsData> {
    constructor () {
        super({})
    }

    async loadData () {
        const res = await ContentsApi.getAll()

        return this.data = res ?? {}
    }
}

export default new TagsCachedDataService()
